import { isDefine } from 'helpers';

class OptimizationModel {
  static isRate(conditionValue) {
    return typeof conditionValue === 'string' && conditionValue.includes('rate');
  }

  static isDuration(conditionValue) {
    return typeof conditionValue === 'string' && conditionValue.includes('duration');
  }

  static parseConditions(conditions = []) {
    if (!conditions) return [];

    return conditions
      .map((condition) => {
        return {
          ...condition,
          value: Number(condition.value),
        };
      })
      .filter(
        (condition) =>
          isDefine(condition.value) && isDefine(condition.operator) && isDefine(condition.condition)
      );
  }

  static parseInitialConditions(conditions = []) {
    if (!conditions) return [];

    return conditions.map((condition) => {
      return {
        ...condition,
        value: Number(condition.value),
      };
    });
  }
}

export default OptimizationModel;
